export const id = '__single-property-infinite-loop-clone__';
